export default __webpack_public_path__ + "cccaaebeadf8a005a3b1cee4f03396dc.jpg";